import React, { useState, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { BiSolidPhoneCall } from "react-icons/bi";
import { Button } from "react-bootstrap";
import "../App.css";
import { useTranslation } from "react-i18next";
import HelmetSeo from "./HelmetSeo";

const AudioCallStatus = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { t } = useTranslation();
  const [callStatus, setCallStatus] = useState("");

  useEffect(() => {
    console.log("props", location.state);
    setCallStatus(location.state.callStatus);
    setTimeout(() => {
      navigate("/");
    }, 120000);
  }, [location, navigate]);

  return (
    <div>
      <HelmetSeo
        title="Audio Call Status | Vasthuparam"
        content="Track the status of your audio consultation with Vasthuparam experts, Vedic astrology and stay updated on session progress or connection details."
        name="description"
        relCa="canonical"
        hrefCa="https://www.vasthuparam.com/audiocallstatus"
        relAl="alternate"
        hrefAl="https://m.www.vasthuparam.com/audiocallstatus"
      />

      <div className="contnent">
        <div className="hlo">
          <h3>{t(callStatus)}...</h3>{" "}
        </div>
        {location.state &&
        location.state.callStatus === "USR.CAL.PROCED.BTN" ? (
          <div className="call_proceed">
            <BiSolidPhoneCall size={50} />
          </div>
        ) : (
          <div className="call_failed">
            <BiSolidPhoneCall size={50} />
          </div>
        )}
        <div>
          <Button variant="outline-warning" onClick={() => navigate(-1)}>
            {t("TXT.CLO.LO")}
          </Button>
        </div>
      </div>
    </div>
  );
};
export default AudioCallStatus;
